// @flow

export const SharedSetLoading = "SHARED/SET_LOADING";
export const SharedSetLoaded = "SHARED/SET_LOADED";

export const GetHierarchyTree = "SHARED/GET_HIERARCHY_TREE";
export const GetHierarchyTreeSuccess = "SHARED/GET_HIERARCHY_TREE_SUCCESS";
export const GetHierarchyTreeError = "SHARED/GET_HIERARCHY_TREE_ERROR";
export const GetMyHierarchyTreeNew = "SHARED/GET_MY_HIERARCHY_TREE_NEW";
export const GetMyHierarchyTree = "SHARED/GET_MY_HIERARCHY_TREE";
export const GetMyHierarchyTreeSuccess = "SHARED/GET_MY_HIERARCHY_TREE_SUCCESS";
export const GetMyHierarchyTreeError = "SHARED/GET_MY_HIERARCHY_TREE_ERROR";
export const ResetMyHierarchyTree = "SHARED/RESET_MY_HIERARCHY_TREE";

export const GetAbsenceReasons = "SHARED/GET_CLIENT_ABSENCE_REASONS";
export const GetAbsenceReasonsSuccess = "SHARED/GET_CLIENT_ABSENCE_REASONS_SUCCESS";
export const GetAbsenceReasonsError = "SHARED/GET_CLIENT_ABSENCE_REASONS_ERROR";

export const GetAlerts = "SHARED/GET_CLIENT_ALERTS";
export const GetAlertsSuccess = "SHARED/GET_CLIENT_ALERTS_SUCCESS";
export const GetAlertsError = "SHARED/GET_CLIENT_ALERTS_ERROR";

export const GetAlertsSuppressedBy = "GET_ALERTS_SUPPRESSED_BY";
export const GetAlertsSuppressedBySuccess = "GET_ALERTS_SUPPRESSED_BY_SUCCESS";
export const GetAlertsSuppressedByError = "GET_ALERTS_SUPPRESSED_BY_ERROR";

export const GetAlertsSuppression = "GET_ALERTS_SUPRESSION";
export const GetAlertsSuppressionSuccess = "GET_ALERTS_SUPRESSION_SUCCESS";
export const GetAlertsSuppressionError = "GET_ALERTS_SUPRESSION_ERROR";

export const DeleteAlertsSuppression = "DELETE_ALERTS_SUPRESSION";
export const DeleteAlertsSuppressionSuccess = "DELETE_ALERTS_SUPRESSION_SUCCESS";
export const DeleteAlertsSuppressionError = "DELETE_ALERTS_SUPRESSION_ERROR";

export const AddAlertsSuppression = "ADD_ALERTS_SUPRESSION";
export const AddAlertsSuppressionSuccess = "ADD_ALERTS_SUPRESSION_SUCCESS";
export const AddAlertsSuppressionError = "ADD_ALERTS_SUPRESSION_ERROR";

export const GetAlertsSuppressionOptions = "GET_ALERTS_SUPRESSION_OPTIONS";
export const GetAlertsSuppressionOptionsSuccess = "GET_ALERTS_SUPRESSION_OPTIONS_SUCCESS";
export const GetAlertsSuppressionOptionsError = "GET_ALERTS_SUPRESSION_OPTIONS_ERROR";

export const GetSpecialContactTypes = "SHARED/GET_CLIENT_SPECIAL_CONTACT_TYPES";
export const GetSpecialContactTypesSuccess = "SHARED/GET_CLIENT_SPECIAL_CONTACT_TYPES_SUCCESS";
export const GetSpecialContactTypesError = "SHARED/GET_CLIENT_SPECIAL_CONTACT_TYPES_ERROR";

export const GetClientShiftPatterns = "SHARED/GET_CLIENT_SHIFT_PATTERNS";
export const GetClientShiftPatternsSuccess = "SHARED/GET_CLIENT_SHIFT_PATTERNS_SUCCESS";
export const GetClientShiftPatternsError = "SHARED/GET_CLIENT_SHIFT_PATTERNS_ERROR";

export const GetClientStaffGroups = "SHARED/GET_CLIENT_STAFF_GROUPS";
export const GetClientStaffGroupsSuccess = "SHARED/GET_CLIENT_STAFF_GROUPS_SUCCESS";
export const GetClientStaffGroupsError = "SHARED/GET_CLIENT_STAFF_GROUPS_ERROR";

export const GetWelbeingProviders = "SHARED/GET_WELBEING_PROVIDERS";
export const GetWelbeingProvidersSuccess = "SHARED/GET_WELBEING_PROVIDERS_SUCCESS";
export const GetWelbeingProvidersError = "SHARED/GET_WELBEING_PROVIDERS_ERROR";

// Employee Absences
export const GetEmployeeAbsences = "SHARED/GET_EMPLOYEE_ABSENCES";
export const GetEmployeeAbsencesSuccess = "SHARED/GET_EMPLOYEE_ABSENCES_SUCCESS";
export const GetEmployeeAbsencesError = "SHARED/GET_EMPLOYEE_ABSENCES_ERROR";

export const DeleteEmployeeAbsence = "SHARED/DELETE_EMPLOYEE_ABSENCE";
export const DeleteEmployeeAbsenceSuccess = "SHARED/DELETE_EMPLOYEE_ABSENCES_SUCCESS";
export const DeleteEmployeeAbsenceError = "SHARED/DELETE_EMPLOYEE_ABSENCES_ERROR";

export const GetAbsenceCancelReasons = "SHARED/GET_ABSENCE_CANCEL_REASONS";
export const GetAbsenceCancelReasonsSuccess = "SHARED/GET_ABSENCE_CANCEL_REASONS_SUCCESS";
export const GetAbsenceCancelReasonsError = "SHARED/GET_ABSENCE_CANCEL_REASONS_ERROR";
export const CancelEmployeeAbsence = "SHARED/CANCEL_EMPLOYEE_ABSENCE";
export const CancelEmployeeAbsenceSuccess = "SHARED/CANCEL_EMPLOYEE_ABSENCES_SUCCESS";
export const CancelEmployeeAbsenceError = "SHARED/CANCEL_EMPLOYEE_ABSENCES_ERROR";

export const GetAbsenceTimeLost = "SHARED/GET_ABSENCE_TIME_LOST";
export const GetAbsenceTimeLostSuccess = "SHARED/GET_ABSENCE_TIME_LOST_SUCCESS";
export const GetAbsenceTimeLostError = "SHARED/GET_ABSENCE_TIME_LOST_ERROR";

export const GetEmployeeAbsence = "SHARED/GET_EMPLOYEE_ABSENCE";
export const GetEmployeeAbsenceSuccess = "SHARED/GET_EMPLOYEE_ABSENCE_SUCCESS";
export const GetEmployeeAbsenceError = "SHARED/GET_EMPLOYEE_ABSENCE_ERROR";
export const GetAlertsTriggered = "SHARED/GET_ALERTS_TRIGGERED";

export const CancelAlert = "SHARED/CANCEL_ALERT";
export const CancelAlertSuccess = "SHARED/CANCEL_ALERT_SUCCESS";
export const CancelAlertError = "SHARED/CANCEL_ALERT_ERROR";

export const GetAlertsTriggeredSuccess = "SHARED/GET_ALERTS_TRIGGERED_SUCCESS";
export const GetAlertsTriggeredError = "SHARED/GET_ALERTS_TRIGGERED_ERROR";
export const ToggleAlertsTriggeredModal = "SHARED/TOGGLE_ALERTS_TRIGGERED_MODAL";
export const ToggleAddAbsenceModal = "SHARED/TOGGLE_ADD_ABSENCE_MODAL";
export const ToggleTransferAbsenceModal = "SHARED/TOGGLE_TRANSFER_ABSENCE_MODAL";
export const ToggleTransferAbsenceConfirmationModal =
  "SHARED/TOGGLE_TRANSFER_ABSENCE_CONFIRMATION_MODAL";
export const UpdateAbsenceAddModalData = "SHARED/UPDATE_ABSENCE_ADD_MODAL_DATE";
export const CreateEmployeeAbsence = "SHARED/CREATE_EMPLOYEE_ABSENCE";
export const CreateEmployeeAbsenceSuccess = "SHARED/CREATE_EMPLOYEE_ABSENCE_SUCCESS";
export const CreateEmployeeAbsenceError = "SHARED/CREATE_EMPLOYEE_ABSENCE_ERROR";
export const UpdateEmployeeAbsence = "SHARED/UPDATE_EMPLOYEE_ABSENCE";
export const UpdateEmployeeAbsenceSuccess = "SHARED/UPDATE_EMPLOYEE_ABSENCE_SUCCESS";
export const UpdateEmployeeAbsenceError = "SHARED/UPDATE_EMPLOYEE_ABSENCE_ERROR";
export const ExportEmployeeAbsenceHistory = "SHARED/EXPORT_EMPLOYEE_ABSENCE_HISTORY";
export const ExportEmployeeAbsenceHistorySuccess = "SHARED/EXPORT_EMPLOYEE_ABSENCE_HISTORY_SUCCESS";
export const ExportEmployeeAbsenceHistoryError = "SHARED/EXPORT_EMPLOYEE_ABSENCE_HISTORY_ERROR";
export const GetEmployeeAbsencesSchema = "SHARED/GET_EMPLOYEE_ABSENCE_SCHEMA";
export const GetEmployeeAbsencesSchemaSuccess = "SHARED/GET_EMPLOYEE_ABSENCE_SCHEMA_SUCCESS";
export const GetEmployeeAbsencesSchemaError = "SHARED/GET_EMPLOYEE_ABSENCE_SCHEMA_ERROR";
export const GetEmployeeAbsenceShiftPattern = "SHARED/GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN";
export const GetEmployeeAbsenceShiftPatternSuccess =
  "SHARED/GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN_SUCCESS";
export const GetEmployeeAbsenceShiftPatternError =
  "SHARED/GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN_ERROR";
export const GetEmployeeAbsenceShiftPatternOptions =
  "SHARED/GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN_OPTIONS";
export const GetEmployeeAbsenceShiftPatternOptionsSuccess =
  "GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN_OPTIONS_SUCCESS";
export const GetEmployeeAbsenceShiftPatternOptionsError =
  "GET_EMPLOYEE_ABSENCE_SHIFT_PATTERN_OPTIONS_ERROR";
export const ToggleEmployeeAbsenceShiftPatternModal =
  "SHARED/TOGGLE_EMPLOYEE_ABSENCE_SHIFT_PATTERN_MODAL";
export const UpdateEmployeeAbsenceShiftPattern = "SHARED/UPDATE_EMPLOYEE_ABSENCE_SHIFT_PATTERN";
export const UpdateAbsence = "SHARED/UPDATE_ABSENCE";
export const UpdateAbsenceSuccess = "SHARED/UPDATE_ABSENCE_SUCCESS";
export const UpdateAbsenceError = "SHARED/UPDATE_ABSENCE_ERROR";
export const CreateAbsence = "SHARED/CREATE_ABSENCE";
export const CreateAbsenceSuccess = "SHARED/CREATE_ABSENCE_SUCCESS";
export const CreateAbsenceError = "SHARED/CREATE_ABSENCE_ERROR";
export const UpdateEmployeeAbsenceShiftPatternSuccess =
  "SHARED/UPDATE_EMPLOYEE_ABSENCE_SHIFT_PATTERN_SUCCESS";
export const UpdateEmployeeAbsenceShiftPatternError =
  "SHARED/UPDATE_EMPLOYEE_ABSENCE_SHIFT_PATTERN_ERROR";
export const GetEmployeeInteractions = "SHARED/GET_EMPLOYEE_INTERACTIONS";
export const GetEmployeeInteractionsSuccess = "SHARED/GET_EMPLOYEE_INTERACTIONS_SUCCESS";
export const GetEmployeeInteractionsError = "SHARED/GET_EMPLOYEE_INTERACTIONS_ERROR";
export const UpdateEmployeeInteraction = "SHARED/UPDATE_EMPLOYEE_INTERACTION";
export const UpdateEmployeeInteractionSuccess = "SHARED/UPDATE_EMPLOYEE_INTERACTION_SUCCESS";
export const UpdateEmployeeInteractionError = "SHARED/UPDATE_EMPLOYEE_INTERACTION_ERROR";
export const ToggleEditEmployeeInteractionModal = "SHARED/TOGGLE_EDIT_EMPLOYEE_INTERACTION_MODAL";
export const GetEmployeeAbsenceAdditionalInfo = "SHARED/GET_EMPLOYEE_ABSENCE_ADDITIONAL_INFO";
export const GetEmployeeAbsenceAdditionalInfoSuccess =
  "GET_EMPLOYEE_ABSENCE_ADDITIONAL_INFO_SUCCESS";
export const GetEmployeeAbsenceAdditionalInfoError =
  "SHARED/GET_EMPLOYEE_ABSENCE_ADDITIONAL_INFO_ERROR";
export const UpdateEmployeeAbsenceAdditionalInfo = "SHARED/UPDATE_EMPLOYEE_ABSENCE_ADDITIONAL_INFO";
export const UpdateEmployeeAbsenceAdditionalInfoSuccess =
  "UPDATE_EMPLOYEE_ABSENCE_ADDITIONAL_INFO_SUCCESS";
export const UpdateEmployeeAbsenceAdditionalInfoError =
  "UPDATE_EMPLOYEE_ABSENCE_ADDITIONAL_INFO_ERROR";
export const ToggleEditEmployeeAbsenceAdditionalInfoModal =
  "TOGGLE_EDIT_EMPLOYEE_ABSENCE_ADDITIONAL_INFO_MODAL";
export const GetEmployeeBankHolidaysOptions = "SHARED/GET_EMPLOYEE_BANK_HOLIDAYS_OPTIONS";
export const GetEmployeeBankHolidaysOptionsSuccess =
  "SHARED/GET_EMPLOYEE_BANK_HOLIDAYS_OPTIONS_SUCCESS";
export const GetEmployeeBankHolidaysOptionsError =
  "SHARED/GET_EMPLOYEE_BANK_HOLIDAYS_OPTIONS_ERROR";

//Revision history
export const GetRevisionHistory = "SHARED/GET_REVISION_HISTORY";
export const GetRevisionHistorySuccess = "SHARED/GET_REVISION_HISTORY_SUCCESS";
export const GetRevisionHistoryError = "SHARED/GET_REVISION_HISTORY_ERROR";

export const ToggleIndividualsRevisionHistoryModal = "TOGGLE_REVISION_HISTORY_MODAL";
export const GetIndividualsRevisionHistory = "GET_INDIVIDUALS_REVISION_HISTORY";
export const GetIndividualsRevisionHistorySuccess = "GET_INDIVIDUALS_REVISION_HISTORY_SUCCESS";
export const GetIndividualsRevisionHistoryError = "GET_INDIVIDUALS_REVISION_HISTORY_ERROR";

export const GetEmployeeSMSMessages = "SHARED/GET_EMPLOYEE_SMSMESSAGES";
export const GetEmployeeSMSMessagesSuccess = "SHARED/GET_EMPLOYEE_SMSMESSAGES_SUCCESS";
export const GetEmployeeSMSMessagesError = "SHARED/GET_EMPLOYEE_SMSMESSAGES_ERROR";

// EMPLOYEE ABSENCE DOCUMENT
export const GetEmployeeAbsenceDocuments = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENTS";
export const GetEmployeeAbsenceDocumentsSuccess = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENTS_SUCCESS";
export const GetEmployeeAbsenceDocumentsError = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENTS_ERROR";
export const ToggleEmployeeAbsenceDocumentModal = "SHARED/TOGGLE_EMPLOYEE_ABSENCE_DOCUMENT_MODAL";
export const CreateEmployeeAbsenceDocument = "SHARED/CREATE_EMPLOYEE_ABSENCE_DOCUMENT";
export const CreateEmployeeAbsenceDocumentSuccess =
  "SHARED/CREATE_EMPLOYEE_ABSENCE_DOCUMENT_SUCCESS";
export const CreateEmployeeAbsenceDocumentError = "SHARED/CREATE_EMPLOYEE_ABSENCE_DOCUMENT_ERROR";
export const GetEmployeeAbsenceDocument = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENT";
export const GetEmployeeAbsenceDocumentSuccess = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENT_SUCCESS";
export const GetEmployeeAbsenceDocumentError = "SHARED/GET_EMPLOYEE_ABSENCE_DOCUMENT_ERROR";
export const DeleteEmployeeAbsenceDocument = "SHARED/DELETE_EMPLOYEE_ABSENCE_DOCUMENT";
export const DeleteEmployeeAbsenceDocumentSuccess =
  "SHARED/DELETE_EMPLOYEE_ABSENCE_DOCUMENT_SUCCESS";
export const DeleteEmployeeAbsenceDocumentError = "SHARED/DELETE_EMPLOYEE_ABSENCE_DOCUMENT_ERROR";
export const ToggleDeleteEmployeeAbsenceDocumentModal =
  "TOGGLE_DELETE_EMPLOYEE_ABSENCE_DOCUMENT_MODAL";

export const GetManagerNotes = "SHARED/GET_MANAGER_NOTES";
export const GetManagerNotesSuccess = "SHARED/GET_MANAGER_NOTES_SUCCESS";
export const GetManagerNotesError = "SHARED/GET_MANAGER_NOTES_ERROR";

export const ExportManagerNotes = "SHARED/EXPORT_MANAGER_NOTES";
export const ExportManagerNotesSuccess = "SHARED/EXPORT_MANAGER_NOTES_SUCCESS";
export const ExportManagerNotesError = "SHARED/EXPORT_MANAGER_NOTES_ERROR";

export const AddManagerNote = "SHARED/ADD_MANAGER_NOTE";
export const AddManagerNoteSuccess = "SHARED/ADD_MANAGER_NOTE_SUCCESS";
export const AddManagerNoteError = "SHARED/ADD_MANAGER_NOTE_ERROR";

export const EditManagerNote = "SHARED/EDIT_MANAGER_NOTE";
export const EditManagerNoteSuccess = "SHARED/EDIT_MANAGER_NOTE_SUCCESS";
export const EditManagerNoteError = "SHARED/EDIT_MANAGER_NOTE_ERROR";

export const DeleteManagerNote = "SHARED/DELETE_MANAGER_NOTE";
export const DeleteManagerNoteSuccess = "SHARED/DELETE_MANAGER_NOTE_SUCCESS";
export const DeleteManagerNoteError = "SHARED/DELETE_MANAGER_NOTE_ERROR";

export const ToggleDeleteManagerNoteModal = "SHARED/TOGGLE_DELETE_MANAGER_NOTE_MODAL";

export const GetAbsenceManagerNotesSchema = "SHARED/GET_ABSENCE_MANAGER_NOTES_SCHEMA";
export const GetAbsenceManagerNotesSchemaSuccess =
  "SHARED/GET_ABSENCE_MANAGER_NOTES_SCHEMA_SUCCESS";
export const GetAbsenceManagerNotesSchemaError = "SHARED/GET_ABSENCE_MANAGER_NOTES_SCHEMA_ERROR";

export const ToggleAddEditManagerNotesModal = "SHARED/TOGGLE_ADD_EDIT_MANAGER_NOTES_MODAL";

export const GetEmployeeAbsenceNotifications = "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATIONS";
export const GetEmployeeAbsenceNotificationsSuccess =
  "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATIONS_SUCCESS";
export const GetEmployeeAbsenceNotificationsError =
  "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATIONS_ERROR";
export const GetEmployeeAbsenceNotification = "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATION";
export const GetEmployeeAbsenceNotificationSuccess =
  "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATION_SUCCESS";
export const GetEmployeeAbsenceNotificationError = "SHARED/GET_EMPLOYEE_ABSENCE_NOTIFICATION_ERROR";
export const ToggleEmployeeAbsenceNotificationModal =
  "SHARED/TOGGLE_EMPLOYEE_ABSENCE_NOTIFICATION_MODAL";

// Absence Statistics
export const GetAbsenceStatistics = "SHARED/GET_ABSENCE_STATISTICS";
export const GetAbsenceStatisticsSuccess = "SHARED/GET_ABSENCE_STATISTICS_SUCCESS";
export const GetAbsenceStatisticsError = "SHARED/GET_ABSENCE_STATISTICS_ERROR";

// Manager Notifications
export const CreateManagerNotification = "SHARED/CREATE_MANAGER_NOTIFICATION";
export const DeleteManagerNotificationList = "SHARED/DELETE_MANAGER_NOTIFICATION_LIST";
export const UpdateManagerNotification = "SHARED/UPDATE_MANAGER_NOTIFICATION";

// Recipient Notifications
export const GetNotifications = "SHARED/GET_NOTIFICATIONS";
export const GetNotificationsSuccess = "SHARED/GET_NOTIFICATIONS_SUCCESS";
export const GetNotificationsError = "SHARED/GET_NOTIFICATIONS_ERROR";
export const GetMyEmployeeNotifications = "SHARED/GET_MY_EMPLOYEE_NOTIFICATIONS";
export const GetMyEmployeeNotificationsSuccess = "SHARED/GET_MY_EMPLOYEE_NOTIFICATIONS_SUCCESS";
export const GetMyEmployeeNotificationsError = "SHARED/GET_MY_EMPLOYEE_NOTIFICATIONS_ERROR";
export const CreateNotification = "SHARED/CREATE_NOTIFICATION";
export const CreateNotificationSuccess = "SHARED/CREATE_NOTIFICATION_SUCCESS";
export const CreateNotificationError = "SHARED/CREATE_NOTIFICATION_ERROR";
export const UpdateNotification = "SHARED/UPDATE_NOTIFICATION";
export const UpdateNotificationSuccess = "SHARED/UPDATE_NOTIFICATION_SUCCESS";
export const UpdateNotificationError = "SHARED/UPDATE_NOTIFICATION_ERROR";
export const DeleteNotificationList = "SHARED/DELETE_NOTIFICATION_LIST";
export const DeleteNotificationListSuccess = "SHARED/DELETE_NOTIFICATION_LIST_SUCCESS";
export const DeleteNotificationListError = "SHARED/DELETE_NOTIFICATION_LIST_ERROR";
export const TransferNotificationList = "SHARED/TRANSFER_NOTIFICATION_LIST";
export const TransferNotificationListSuccess = "SHARED/TRANSFER_NOTIFICATION_LIST_SUCCESS";
export const TransferNotificationListError = "SHARED/TRANSFER_NOTIFICATION_LIST_ERROR";
export const CopyNotificationList = "SHARED/COPY_NOTIFICATION_LIST";
export const CopyNotificationListSuccess = "SHARED/COPY_NOTIFICATION_LIST_SUCCESS";
export const CopyNotificationListError = "SHARED/COPY_NOTIFICATION_LIST_ERROR";

// Target Notifications
export const GetNotificationsTargets = "SHARED/GET_NOTIFICATIONS_TARGETS";
export const GetNotificationsTargetsSuccess = "SHARED/GET_NOTIFICATIONS_TARGETS_SUCCESS";
export const GetNotificationsTargetsError = "SHARED/GET_NOTIFICATIONS_TARGETS_ERROR";
export const CreateNotificationTarget = "SHARED/CREATE_NOTIFICATION_TARGET";
export const CreateNotificationTargetSuccess = "SHARED/CREATE_NOTIFICATION_TARGET_SUCCESS";
export const CreateNotificationTargetError = "SHARED/CREATE_NOTIFICATION_TARGET_ERROR";
export const UpdateNotificationTarget = "SHARED/UPDATE_NOTIFICATION_TARGET";
export const UpdateNotificationTargetSuccess = "SHARED/UPDATE_NOTIFICATION_TARGET_SUCCESS";
export const UpdateNotificationTargetError = "SHARED/UPDATE_NOTIFICATION_TARGET_ERROR";
export const DeleteNotificationTargetList = "SHARED/DELETE_NOTIFICATION_TARGET_LIST";
export const DeleteNotificationTargetListSuccess = "SHARED/DELETE_NOTIFICATION_TARGET_LIST_SUCCESS";
export const DeleteNotificationTargetListError = "SHARED/DELETE_NOTIFICATION_TARGET_LIST_ERROR";
export const TransferNotificationTargetList = "SHARED/TRANSFER_NOTIFICATION_TARGET_LIST";
export const TransferNotificationTargetListSuccess =
  "SHARED/TRANSFER_NOTIFICATION_TARGET_LIST_SUCCESS";
export const TransferNotificationTargetListError = "SHARED/TRANSFER_NOTIFICATION_TARGET_LIST_ERROR";
export const CopyNotificationTargetList = "SHARED/COPY_NOTIFICATION_TARGET_LIST";
export const CopyNotificationTargetListSuccess = "SHARED/COPY_NOTIFICATION_TARGET_LIST_SUCCESS";
export const CopyNotificationTargetListError = "SHARED/COPY_NOTIFICATION_TARGET_LIST_ERROR";

// Department Notifications
export const GetHierarchyNotifications = "SHARED/GET_HIERARCHY_NOTIFICATIONS";
export const GetHierarchyNotificationsSuccess = "SHARED/GET_HIERARCHY_NOTIFICATIONS_SUCCESS";
export const GetHierarchyNotificationsError = "SHARED/GET_HIERARCHY_NOTIFICATIONS_ERROR";
export const GetHierarchyNotificationsTargets = "SHARED/GET_HIERARCHY_NOTIFICATIONS_TARGETS";
export const GetHierarchyNotificationsTargetsSuccess =
  "GET_HIERARCHY_NOTIFICATIONS_TARGETS_SUCCESS";
export const GetHierarchyNotificationsTargetsError =
  "SHARED/GET_HIERARCHY_NOTIFICATIONS_TARGETS_ERROR";

export const GetNotificationSchema = "SHARED/GET_NOTIFICATION_SCHEMA";
export const GetNotificationSchemaSuccess = "SHARED/GET_NOTIFICATION_SCHEMA_SUCCESS";
export const GetNotificationSchemaError = "SHARED/GET_NOTIFICATION_SCHEMA_ERROR";
export const ToggleAddNotificationModal = "SHARED/TOGGLE_ADD_NOTIFICATION_MODAL";
export const ToggleEditNotificationModal = "SHARED/TOGGLE_EDIT_NOTIFICATION_MODAL";
export const GetNotificationEmployee = "SHARED/GET_NOTIFICATION_EMPLOYEE";
export const GetNotificationEmployeeError = "SHARED/GET_NOTIFICATION_EMPLOYEE_ERROR";
export const GetAddNotificationModalEmployeeList =
  "SHARED/GET_ADD_NOTIFICATION_MODAL_EMPLOYEE_LIST";
export const GetAddNotificationModalEmployeeListSuccess =
  "GET_ADD_NOTIFICATION_MODAL_EMPLOYEE_LIST_SUCCESS";
export const GetAddNotificationModalEmployeeListError =
  "GET_ADD_NOTIFICATION_MODAL_EMPLOYEE_LIST_ERROR";

// Employee Positions
export const GetSharedEmployeePositions = "SHARED/GET_SHARED_EMPLOYEE_POSITIONS";
export const GetSharedEmployeePositionsSuccess = "SHARED/GET_SHARED_EMPLOYEE_POSITIONS_SUCCESS";
export const GetSharedEmployeePositionsError = "SHARED/GET_SHARED_EMPLOYEE_POSITIONS_ERROR";

// Employee Events
export const GetEmployeeDocuments = "SHARED/GET_EMPLOYEE_DOCUMENTS";
export const GetEmployeeDocumentsSuccess = "SHARED/GET_EMPLOYEE_DOCUMENTS_SUCCESS";
export const GetEmployeeDocumentsError = "SHARED/GET_EMPLOYEE_DOCUMENTS_ERROR";
export const GetEmployeeSpecificDocuments = "SHARED/GET_EMPLOYEE_SPECIFIC_DOCUMENTS";
export const GetEmployeeSpecificDocumentsSuccess = "SHARED/GET_EMPLOYEE_SPECIFIC_DOCUMENTS_SUCCESS";
export const GetEmployeeSpecificDocumentsError = "SHARED/GET_EMPLOYEE_SPECIFIC_DOCUMENTS_ERROR";
export const ToggleRemoveEmployeeDocumentModal = "SHARED/TOGGLE_REMOVE_EMPLOYEE_DOCUMENT_MODAL";
export const RemoveEmployeeDocument = "SHARED/REMOVE_EMPLOYEE_DOCUMENT";
export const RemoveEmployeeDocumentError = "SHARED/REMOVE_EMPLOYEE_DOCUMENT_ERROR";
export const ToggleAddEmployeeDocumentModal = "SHARED/TOGGLE_ADD_EMPLOYEE_DOCUMENT_MODAL";
export const AddEmployeeDocument = "SHARED/ADD_EMPLOYEE_DOCUMENT";
export const AddEmployeeDocumentError = "SHARED/ADD_EMPLOYEE_DOCUMENT_ERROR";
export const DownloadEmployeeDocument = "SHARED/DOWNLOAD_EMPLOYEE_DOCUMENT";
export const DownloadEmployeeDocumentSuccess = "SHARED/DOWNLOAD_EMPLOYEE_DOCUMENT_SUCCESS";
export const DownloadEmployeeDocumentError = "SHARED/DOWNLOAD_EMPLOYEE_DOCUMENT_ERROR";
export const GetEmployeeEventHistory = "SHARED/GET_EMPLOYEE_EVENT_HISTORY";
export const GetEmployeeEventHistorySuccess = "SHARED/GET_EMPLOYEE_EVENT_HISTORY_SUCCESS";
export const GetEmployeeEventHistoryError = "SHARED/GET_EMPLOYEE_EVENT_HISTORY_ERROR";
export const ResetEmployeeEventHistory = "SHARED/RESET_EMPLOYEE_EVENT_HISTORY";
export const GetManualReferralEnabled = "SHARED/GET_MANUAL_REFERRAL_ENABLED";
export const GetManualReferralEnabledSuccess = "SHARED/GET_MANUAL_REFERRAL_ENABLED_SUCCESS";
export const GetManualReferralEnabledError = "SHARED/GET_MANUAL_REFERRAL_ENABLED_ERROR";
export const GetReferralProcesses = "SHARED/GET_REFERRAL_PROCESSES";
export const GetReferralProcessesSuccess = "SHARED/GET_REFERRAL_PROCESSES_SUCCESS";
export const GetReferralProcessesError = "SHARED/GET_REFERRAL_PROCESSES_ERROR";
export const ToggleMonitoringUpdateModal = "SHARED/TOGGLE_MONITORING_UPDATE_MODAL";
export const ToggleManualReferralModal = "SHARED/TOGGLE_MANUAL_REFERRAL_MODAL";
export const PostManualReferral = "SHARED/POST_MANUAL_REFERRAL";
export const PostManualReferralSuccess = "SHARED/POST_MANUAL_REFERRAL_SUCCESS";
export const PostManualReferralError = "SHARED/POST_MANUAL_REFERRAL_ERROR";
export const ToggleEventHistoryItemModal = "SHARED/TOGGLE_EVENT_HISTORY_ITEM_MODAL";
export const ToggleAbsenceReviewModal = "SHARED/TOGGLE_ABSENCE_REVIEW_MODAL";
export const ToggleReferralDecisionModal = "SHARED/TOGGLE_REFERRAL_DECISION_MODAL";

export const GetEmployeesList = "SHARED/GET_EMPLOYEES_LIST";
export const GetEmployeesListSuccess = "SHARED/GET_EMPLOYEES_LIST_SUCCESS";
export const GetEmployeesListError = "SHARED/GET_EMPLOYEES_LIST_ERROR";
export const SelectEmployee = "SHARED/SELECT_EMPLOYEE";
export const ResetSelectedEmployees = "SHARED/RESET_SELECTED_EMPLOYEES";

export const GetEmployeePositionsList = "SHARED/GET_EMPLOYEE_POSITIONS_LIST";
export const GetEmployeePositionsListSuccess = "SHARED/GET_EMPLOYEE_POSITIONS_LIST_SUCCESS";
export const GetEmployeePositionsListError = "SHARED/GET_EMPLOYEE_POSITIONS_LIST_ERROR";
export const SelectEmployeePosition = "SHARED/SELECT_EMPLOYEE_POSITION";

export const SubmitTransferAbsence = "SHARED/SUBMIT_TRANSFER_ABSENCE";
export const SubmitTransferAbsenceSuccess = "SHARED/SUBMIT_TRANSFER_ABSENCE_SUCCESS";
export const SubmitTransferAbsenceError = "SHARED/SUBMIT_TRANSFER_ABSENCE_ERROR";

// Absence Review

export const CreateAbsenceReviewTask = "SHARED/CREATE_ABSENCE_REVIEW_TASK";
export const CreateAbsenceReviewTaskSuccess = "SHARED/CREATE_ABSENCE_REVIEW_TASK_SUCCESS";
export const CreateAbsenceReviewTaskError = "SHARED/CREATE_ABSENCE_REVIEW_TASK_ERROR";
export const GetLastAbsenceReviewTask = "SHARED/GET_LAST_ABSENCE_REVIEW_TASK";
export const GetLastAbsenceReviewTaskSuccess = "SHARED/GET_LAST_ABSENCE_REVIEW_TASK_SUCCESS";
export const GetLastAbsenceReviewTaskError = "SHARED/GET_LAST_ABSENCE_REVIEW_TASK_ERROR";
export const GetAbsenceReviewTask = "SHARED/GET_ABSENCE_REVIEW_TASK";
export const GetAbsenceReviewTaskSuccess = "SHARED/GET_ABSENCE_REVIEW_TASK_SUCCESS";
export const GetAbsenceReviewTaskError = "SHARED/GET_ABSENCE_REVIEW_TASK_ERROR";
export const GetReferralDecisionTaskData = "SHARED/GET_REFERRAL_DECISION_TASK_DATA";
export const GetReferralDecisionTaskDataSuccess = "SHARED/GET_REFERRAL_DECISION_TASK_DATA_SUCCESS";
export const GetReferralDecisionTaskDataError = "SHARED/GET_REFERRAL_DECISION_TASK_DATA_ERROR";
export const GetManualReferralTaskData = "SHARED/GET_MANUAL_REFERRAL_TASK_DATA";
export const GetManualReferralTaskDataSuccess = "SHARED/GET_MANUAL_REFERRAL_TASK_DATA_SUCCESS";
export const GetManualReferralTaskDataError = "SHARED/GET_MANUAL_REFERRAL_TASK_DATA_ERROR";
export const ToggleManualReferralTaskDataModal = "SHARED/TOGGLE_MANUAL_REFERRAL_TASK_DATA_MODAL";
export const CancelAbsenceReviewTask = "SHARED/CANCEL_ABSENCE_REVIEW_TASK";
export const CancelAbsenceReviewTaskSuccess = "SHARED/CANCEL_ABSENCE_REVIEW_TASK_SUCCESS";
export const CancelAbsenceReviewTaskError = "SHARED/CANCEL_ABSENCE_REVIEW_TASK_ERROR";
export const SubmitAbsenceReviewTask = "SHARED/SUBMIT_ABSENCE_REVIEW_TASK";
export const SubmitAbsenceReviewTaskSuccess = "SHARED/SUBMIT_ABSENCE_REVIEW_TASK_SUCCESS";
export const SubmitAbsenceReviewTaskError = "SHARED/SUBMIT_ABSENCE_REVIEW_TASK_ERROR";

export const SetVisibleAbsenceRateTrendRTWInterviewModal =
  "SHARED/SET_VISIBLE_ABSENCE_RATE_TREND_RTW_INTERVIEW_MODAL";
export const CancelRtwInterview = "CANCEL_RTW_INTERVIEW";
export const CancelRtwInterviewSuccess = "CANCEL_RTW_INTERVIEW_SUCCESS";
export const CancelRtwInterviewError = "CANCEL_RTW_INTERVIEW_ERROR";
export const DeleteRtwInterview = "DELETE_RTW_INTERVIEW";
export const DeleteRtwInterviewSuccess = "DELETE_RTW_INTERVIEW_SUCCESS";
export const DeleteRtwInterviewError = "DELETE_RTW_INTERVIEW_ERROR";
export const RebuildRtwInterview = "REBUILD_RTW_INTERVIEW";
export const RebuildRtwInterviewSuccess = "REBUILD_RTW_INTERVIEW_SUCCESS";
export const RebuildRtwInterviewError = "REBUILD_RTW_INTERVIEW_ERROR";

// Absence notes
export const GetAbsenceNoteTypes = "GET_ABSENCE_NOTE_TYPES";
export const GetAbsenceNoteTypesSuccess = "GET_ABSENCE_NOTE_TYPES_SUCCESS";
export const GetAbsenceNoteTypesError = "GET_ABSENCE_NOTE_TYPES_ERROR";

export const GetEmployeeNonCancelledAbsences = "GET_EMPLOYEE_NON_CANCELLED_ABSENCES";
export const GetEmployeeNonCancelledAbsencesSuccess = "GET_EMPLOYEE_NON_CANCELLED_ABSENCES_SUCCESS";
export const GetEmployeeNonCancelledAbsencesError = "GET_EMPLOYEE_NON_CANCELLED_ABSENCES_ERROR";

export const SaveEmployeeRecordAccess = "SHARED/SAVE_EMPLOYEE_RECORD_ACCESS";
export const SaveEmployeeRecordAccessSuccess = "SHARED/SAVE_EMPLOYEE_RECORD_ACCESS_SUCCESS";
export const SaveEmployeeRecordAccessError = "SHARED/SAVE_EMPLOYEE_RECORD_ACCESS_ERROR";
export const SaveAbsenceRecordAccess = "SHARED/SAVE_ABSENCE_RECORD_ACCESS";
export const SaveAbsenceRecordAccessSuccess = "SHARED/SAVE_ABSENCE_RECORD_ACCESS_SUCCESS";
export const SaveAbsenceRecordAccessError = "SHARED/SAVE_ABSENCE_RECORD_ACCESS_ERROR";

// Notification Audit
export const SearchNotificationAuditByStatus = "SEARCH_NOTIFICATION_AUDIT_BY_STATUS";
export const SearchNotificationAuditByStatusSuccess = "SEARCH_NOTIFICATION_AUDIT_BY_STATUS_SUCCESS";
export const SearchNotificationAuditByStatusError = "SEARCH_NOTIFICATION_AUDIT_BY_STATUS_ERROR";

export const UpdateNotificationAuditStatus = "UPDATE_NOTIFICATION_AUDIT_STATUS";
export const UpdateNotificationAuditStatusSuccess = "UPDATE_NOTIFICATION_AUDIT_STATUS_SUCCESS";
export const UpdateNotificationAuditStatusError = "UPDATE_NOTIFICATION_AUDIT_STATUS_ERROR";

export const NotificationAuditRemoveAccessToRecord = "NOTIFICATION_AUDIT_REMOVE_ACCESS_TO_RECORD";
export const NotificationAuditRemoveAccessToRecordSuccess =
  "NOTIFICATION_AUDIT_REMOVE_ACCESS_TO_RECORD_SUCCESS";
export const NotificationAuditRemoveAccessToRecordError =
  "NOTIFICATION_AUDIT_REMOVE_ACCESS_TO_RECORD_ERROR";

export const NotificationAuditComplete = "NOTIFICATION_AUDIT_COMPLETE";
export const NotificationAuditCompleteSuccess = "NOTIFICATION_AUDIT_COMPLETE_SUCCESS";
export const NotificationAuditCompleteError = "NOTIFICATION_AUDIT_COMPLETE_ERROR";

export const GetWellbeingProviders = "GET_WELLBEING_PROVIDERS";
export const GetWellbeingProvidersSuccess = "GET_WELLBEING_PROVIDERS_SUCCESS";
export const GetWellbeingProvidersError = "GET_WELLBEING_PROVIDERS_ERROR";

// system message and release notes
export const GetMessagesLoginText = "GET_MESSAGES_LOGIN_TEXT";
export const GetMessagesLoginTextSuccess = "GET_MESSAGES_LOGIN_TEXT_SUCCESS";
export const GetMessagesLoginTextError = "GET_MESSAGES_LOGIN_TEXT_ERROR";
export const GetMessagesReleaseVersion = "GET_MESSAGES_RELEASE_VERSION";
export const GetMessagesReleaseVersionSuccess = "GET_MESSAGES_RELEASE_VERSION_SUCCESS";
export const GetMessagesReleaseVersionError = "GET_MESSAGES_RELEASE_VERSION_ERROR";
export const GetReleaseNotesDocument = "GET_RELEASE_NOTES_DOCUMENT";
export const GetReleaseNotesDocumentSuccess = "GET_RELEASE_NOTES_DOCUMENT_SUCCESS";
export const GetReleaseNotesDocumentError = "GET_RELEASE_NOTES_DOCUMENT_ERROR";
